import React from 'react'

const CommingSoon = () => {
  return (
    <section className="error-page">
    <div className="container">
        <div className="row">
            <div className="col-xl-12">
                <div className="error-page__inner">
                    <h2 className="comingsoon-page__title">COMING SOON</h2>
                    <h3 className="error-page__tagline">Stay tuned, we're almost there!
                    </h3>
                    <p className="error-page__text">This page will be live soon! Stay tuned for more updates.</p>
                    <a href="/" className="thm-btn error-page__btn" style={{marginTop: '12px'}}>back to home</a>
                </div>
            </div>
        </div>
    </div>
</section>
  )
}

export default CommingSoon